import React from 'react';

import { useSelector } from 'react-redux';

import 'Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less';

import { Col, Row, Typography } from 'antd';

import {
  VertModal,
  VertContainer,
  VertInput,
  VertTypography,
} from '@vertem-core/vertice-ds';

import { formatToString } from 'Utils/format';

import { shouldConvertToPoints } from 'Constants/Concierge';

const ViewDetailsConciergeItemModal = ({ isOpen, onClose, item }) => {
  const Catalog = useSelector(({ Catalog: data }) => data);
  const { currencyConfiguration: { pointsName } } = Catalog;

  return (
    <VertModal
      destroyOnClose={false}
      closable
      open={isOpen}
      onCancel={onClose}
      className="view-details-concierge-modal width-modal"
    >
      <VertContainer className="text-weight-modal-confirmation text-align-details">
        <Col>
          <Typography.Title>
            Detalhes do produto/serviço
          </Typography.Title>
        </Col>
        <Row gutter={8}>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <VertInput
              disabled
              type='text'
              label="Categoria"
              className='field-disabled'
              value={item.category}
            />
          </Col>

          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <VertInput
              disabled
              type='text'
              label="Subcategoria"
              className='field-disabled'
              value={item.subCategory}
            />
          </Col>
        </Row>

        <Row gutter={[8, 8]} className='margin-top-extra-small'>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <VertInput
              disabled
              type='text'
              label="Nome do produto/serviço"
              className='field-disabled'
              value={item.title}
            />
          </Col>

          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <VertInput
              disabled
              label="Qtd."
              className='field-disabled'
              value={item.quantity}
            />
          </Col>

          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <VertInput
              disabled
              label="Valor unitário"
              className='field-disabled'
              value={formatToString(Number(item.unitValue), "currency")}
            />
          </Col>

          {
            shouldConvertToPoints && (
              <>
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <VertInput
                    disabled
                    label={`Valor unit. em ${pointsName}`}
                    className='field-disabled'
                    value={`${item.pointsValue} ${pointsName}`}
                  />
                </Col>
      
                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                  <VertInput
                    disabled
                    label={`Total em ${pointsName}`}
                    className='field-disabled'
                    value={`${item.pointsTotalValue} ${pointsName}`}
                  />
                </Col>
              </>
            )
          }

          {
            item.description &&
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Row>
                  <VertTypography.Text>Descrição do produto/serviço:</VertTypography.Text>
                </Row>

                <VertInput.TextArea
                  disabled
                  className='text-area-description field-disabled'
                  type='text'
                  maxLength={1000}
                  value={item.description}
                />
              </Col>
          }
        </Row>
      </VertContainer>
    </VertModal >
  );
};

export default ViewDetailsConciergeItemModal;
